import React from "react";
import ContactCreateForm from "../forms/ContactCreateForm";
import { Container } from "@airbus/components-react";


class ContactCreateView extends React.Component {

    constructor(props){
        super(props);

        //Notification params
        this.setNotification=this.props.notificationHandler;  //call parent notification handler
               
        
    }

    componentDidMount(){
        //debugger;
    }

    /**
     * RENDERING
     * @returns dom
     */
    render() { return(
        <Container>

            {/* CREATE CONTACT DISPLAY */}
            <ContactCreateForm notificationHandler={this.setNotification}/>

        </Container>
    )}
    

  

}

export default ContactCreateView;